"use client";

import { EnlargeHint, FeatureImageZoom, FeatureScreenshotPanel, TabletFrame } from "./feature-showcase-section";
import { FEATURE_SHOWCASE_BACKGROUNDS, isTabletShot, shot } from "./feature-showcase-images";
import { useFeatureImageZoomAction } from "./useFeatureImageZoomAction";

// Full-width kiosk screenshot in a tablet frame, click to see it full size.
function TabletHero({ feature }) {
    const { isOpen, open, close } = useFeatureImageZoomAction();

    return (
        <>
            <button
                type="button"
                onClick={open}
                aria-label={`Enlarge screenshot: ${feature.title}`}
                className="group relative block w-full cursor-zoom-in text-left"
            >
                <TabletFrame>
                    <img src={feature.hero_image} alt={feature.title} className="block h-auto w-full" />
                </TabletFrame>
                <EnlargeHint style={{ right: "3%", bottom: "5%" }} />
            </button>
            {isOpen && <FeatureImageZoom src={feature.hero_image} alt={feature.title} onClose={close} />}
        </>
    );
}

// Centered hero: title, short description, then a large image below.
// `footer` sits under the image, inside the hero.
export default function Content({ feature, footer }) {
    const tabletHero = !feature.hero_artwork && isTabletShot(feature.hero_image);

    return (
        <div className="relative isolate overflow-hidden bg-[#efecea]">
            <div className="mx-auto max-w-7xl px-6 pb-20 pt-16 md:pb-28">
                <section className="mx-auto max-w-3xl text-center">
                    <h1 className="text-4xl font-medium leading-tight tracking-tight text-neutral-900 md:text-5xl">
                        {feature.title}
                    </h1>
                    <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-neutral-600 md:text-lg">
                        {feature.description}
                    </p>
                </section>

                <div className={`mx-auto mt-12 md:mt-16 ${tabletHero || feature.hero_wide ? "max-w-7xl" : "max-w-5xl"}`}>
                    {tabletHero ? (
                        <TabletHero feature={feature} />
                    ) : feature.hero_artwork ? (
                        // eslint-disable-next-line @next/next/no-img-element
                        <img src={feature.hero_artwork} alt={feature.title} className="mx-auto block h-auto w-full" />
                    ) : feature.hero_image ? (
                        <FeatureScreenshotPanel
                            aspectClassName="aspect-[4/3] md:aspect-[16/9]"
                            row={{
                                title: feature.title,
                                screenshot: shot(feature.hero_image),
                                background: FEATURE_SHOWCASE_BACKGROUNDS[feature.title.length % FEATURE_SHOWCASE_BACKGROUNDS.length],
                            }}
                        />
                    ) : feature.main_image ? (
                        // eslint-disable-next-line @next/next/no-img-element
                        <img src={feature.main_image} alt={feature.title} className="mx-auto w-full rounded-3xl" />
                    ) : (
                        <section className="mx-auto max-w-md rounded-3xl border border-neutral-200 bg-white p-12 text-center">
                            <p className="mb-4 font-medium uppercase tracking-tighter text-neutral-500">
                                Proven Results
                            </p>
                            <h2 className="mb-2 text-7xl font-black text-neutral-900">
                                {feature.metric.split(" ")[0]}
                            </h2>
                            <p className="text-2xl lowercase text-neutral-400">
                                {feature.metric.split(" ").slice(1).join(" ")}
                            </p>
                        </section>
                    )}
                </div>

                {footer}
            </div>
        </div>
    );
}
